(ns frontend.domain.oppo.calculated-fields
  (:require [frontend.utils :as fu]))

(defn age-in-days-active
  [server-time deal]
  (when (and (number? server-time)
             (= (:oppo/status deal) :oppo.status/ok))
    (when-let [created (:common/created-on deal)]
      (fu/millis->days (- server-time created)))))

(defn age-in-days-on-hold
  [server-time deal]
  (when (and (number? server-time)
             (= (:oppo/status deal) :oppo.status/on-hold))
    (when-let [on-hold-on (:oppo/put-on-hold-on deal)]
      (fu/millis->days (- server-time on-hold-on)))))

(defn throughput-in-weeks-passed
  [deal]
  (when (= (:oppo/status deal) :oppo.status/passed)
    (when-let [created (:common/created-on deal)]
      (when-let [passed-on (:oppo/passed-on deal)]
        (fu/millis->weeks (- passed-on created))))))

(defn throughput-in-weeks-invested
  [deal]
  (when (= (:oppo/status deal) :oppo.status/portfolio)
    (when-let [created (:common/created-on deal)]
      (when-let [portfolio-on (:oppo/moved-to-portfolio-on deal)]
        (fu/millis->weeks (- portfolio-on created))))))

(defn add-calculated-fields
  [server-time deal]
  (merge deal
         (when-let [age-in-days-active (age-in-days-active server-time deal)]
           {:oppo/age-in-days-active age-in-days-active})
         (when-let [age-in-days-on-hold (age-in-days-on-hold server-time deal)]
           {:oppo/age-in-days-on-hold age-in-days-on-hold})
         (when-let [throughput-in-weeks-passed (throughput-in-weeks-passed deal)]
           {:oppo/throughput-in-weeks-passed throughput-in-weeks-passed})
         (when-let [throughput-in-weeks-invested (throughput-in-weeks-invested deal)]
           {:oppo/throughput-in-weeks-invested throughput-in-weeks-invested})))
